import { IExpressionEvaluatorContext } from "@@expressions";
import { useEffect } from "react";
import { MaybePromise } from "../../ExpressionsModule/Models/MaybePromise";
import { IComponent } from "../Models/IComponent";
import { IViewController } from "../Models/IViewController";
import { ComponentService } from "../Services/ComponentService";

export default function useRegisterViewController<T extends IComponent>(
  component: T,
  context: IExpressionEvaluatorContext,
  refresh?: (silentRefresh?: boolean) => MaybePromise,
  close?: (output?: Record<string, any>) => void
) {
  useEffect(() => {
    const componentService = context.GetProperty(ComponentService.KEY) as ComponentService;
    if (componentService) {
      const viewModelController: IViewController = {
        refresh: () => refresh?.(true) ?? Promise.resolve(),
        close: (output) => close?.(output),
      };
      componentService.register(component, viewModelController);
    }
  }, [refresh, close, component, context]);
}
